"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySwitch = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledFormControlLabel = (0, material_1.styled)(material_1.FormControlLabel)({
  [`&.${material_1.formControlLabelClasses.root}`]: {
    display: "flex",
    margin: "-10px 10px -10px 0"
  },
  [`& .${material_1.formControlLabelClasses.label}`]: {
    marginLeft: 10
  }
});
const StyledSwitch = (0, material_1.styled)(material_1.Switch)({
  [`&.${material_1.switchClasses.root}`]: {
    margin: "0 -15px"
  }
});

const SskySwitch = props => {
  const {
    checked,
    onChange,
    disabled,
    color
  } = props;
  let switchProps = {
    checked,
    onChange,
    disabled,
    color
  };

  if (props.icon) {
    switchProps.icon = props.icon;
  }

  if (props.checkedIcon) {
    switchProps.checkedIcon = props.checkedIcon;
  }

  return react_1.default.createElement(material_1.FormGroup, {
    className: props.className,
    id: props.id
  }, react_1.default.createElement(StyledFormControlLabel, {
    control: react_1.default.createElement(StyledSwitch, Object.assign({
      "data-testid": props.dataTestId || `testId-${props.id}`,
      "data-tracking-id": props.dataTrackingId || `tracking-id-${props.id}`
    }, switchProps)),
    label: props.label || ""
  }));
};

exports.SskySwitch = SskySwitch;
SskySwitch.defaultProps = {
  color: "primary"
};
exports.default = react_1.default.memo(SskySwitch);